export default __webpack_public_path__ + "static/media/Abetare Mehmetaj.e2a37d1b.jpeg";